import { Binding } from "../../../../../types";
import { ComponentNode } from "../../RenderTreeContext";

export default function getSchema(componentNode: ComponentNode): Binding[] {
  return componentNode.component.properties.schema || [];
}
